import { MutableRefObject } from 'react';
import { Modal } from '@mui/material';

export const BgrLoader = ({
  visible,
  container,
}: {
  visible: boolean;
  container?: MutableRefObject<null>;
}) => (
  <Modal
    open={visible}
    keepMounted
    container={container?.current}
    sx={{
      position: 'absolute',
      '& .MuiBackdrop-root': {
        background: 'rgba(255,255,255,0.6)',
      },
    }}
  >
    <></>
  </Modal>
);
